module.exports = __webpack_public_path__ + "img/sec5_1_2.a931f9fc.jpg";